var _g, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_75_6341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1655 19.7318C21.3655 18.2408 20.3333 16.0615 20.3333 13.7527V10.5C20.3333 6.3945 17.2214 2.996 13.1905 2.42667V1.16667C13.1905 0.5215 12.6571 0 12 0C11.3428 0 10.8095 0.5215 10.8095 1.16667V2.42667C6.77736 2.996 3.66664 6.3945 3.66664 10.5V13.7527C3.66664 16.0615 2.6345 18.2408 0.823786 19.7412C0.360691 20.1297 0.0952148 20.6943 0.0952148 21.2917C0.0952148 22.4175 1.02974 23.3333 2.17855 23.3333H21.8214C22.9702 23.3333 23.9047 22.4175 23.9047 21.2917C23.9047 20.6943 23.6393 20.1297 23.1655 19.7318Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 28C14.156 28 15.9596 26.4938 16.3738 24.5H7.62622C8.04051 26.4938 9.84408 28 12 28Z",
    fill: "black"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 6.5,
    r: 5.5,
    fill: "#333333",
    stroke: "#FEFEFF",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoti);
export default __webpack_public_path__ + "static/media/noti.050e8c3a.svg";
export { ForwardRef as ReactComponent };